module.exports = __webpack_public_path__ + "img/ico_zyhdsq.2b74d8d6.png";